import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from '@studio-freight/lenis';
import { Navigation, HeroSection } from '@/components/wedding';
import AdminPage from '@/pages/AdminPage';
import EventPage from '@/pages/EventPage';
import QRCodePage from '@/pages/QRCodePage';
import OurStoryPage from '@/pages/OurStoryPage';
import GalleryPage from '@/pages/GalleryPage';
import EventsPage from '@/pages/EventsPage';
import SchedulePage from '@/pages/SchedulePage';
import TravelPage from '@/pages/TravelPage';
import GuestBookPage from '@/pages/GuestBookPage';
import FAQPage from '@/pages/FAQPage';
import RSVPPage from '@/pages/RSVPPage';
import MenuPage from '@/pages/MenuPage';

const HomePage = () => {
  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F5EF]" data-testid="wedding-app">
      {/* Grain texture overlay */}
      <div className="grain-overlay" />

      {/* Navigation — floats transparently over the hero on the homepage */}
      <Navigation />

      {/* Hero-only landing experience. Every other section lives on its own route. */}
      <main>
        <HeroSection />
      </main>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/our-story" element={<OurStoryPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/travel" element={<TravelPage />} />
        <Route path="/guest-book" element={<GuestBookPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/rsvp" element={<RSVPPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/event" element={<EventPage />} />
        <Route path="/qr" element={<QRCodePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
